{/* eslint-disable i18next/no-literal-string */}
import { useToast } from "@chakra-ui/react";
import { useTranslations } from "next-intl";

export const useErrorToast = () => {
  const t = useTranslations("lib.utils");
  const toast = useToast();
  const errorToast = ({
    title = t("errorToastTitle"),
    error,
  }: {
    title?: string;
    error: Error | any
  }) =>
    toast({
      status: "error",
      position: "top",
      isClosable: true,
      title,
      description: error?.message,
    });

  return errorToast;
};

export const useSuccessToast = () => {
  const toast = useToast();
  const successToast = ({
    title,
    description,
  }: {
    title: string;
    description?: string;
  }) =>
    toast({
      status: "success",
      position: "top",
      isClosable: true,
      title,
      description,
    });

  return successToast;
};

export const errorToast = (params: {
  title: string;
  description?: string;
}) => ({
  ...params,
  status: "error",
  position: "top",
  isClosable: true,
  duration: 10000
});

export const successToast = (params: {
  title: string;
  description?: string;
}) => ({
  ...params,
  status: "success",
  position: "top",
  isClosable: true,
  duration: 10000

});


